import { CSPUrlsMap } from '../../routes/CSPUrlsMap';

export const EDICSPConfig = {
  cspConfiguration: {
    partner: 'edi',
    partnerTitle: 'Everyday Pet Insurance',
    auth0Config: {
      sit: {
        authenticationType: '1', // Use 1 value for Auth0 SSO Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'ps-staging-everyday-csp.au.auth0.com',
        appClientId: 'BpVSOYCFUVKxqmDqqnd6SgwV1AjDlX2v',
        cspMfaUrl: '',
        gen2CspUrl: 'https://gen2-petportal-wow-sys.petsure.com.au',
        ssoLoginUrl: 'https://preprod-insurance.everyday.com.au/my-ins-portal/mip.html/login'
      },
      uat: {
        authenticationType: '1', // Use 1 value for Auth0 SSO Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'ps-staging-everyday-csp.au.auth0.com',
        appClientId: 'BpVSOYCFUVKxqmDqqnd6SgwV1AjDlX2v',
        cspMfaUrl: '',
        gen2CspUrl: 'https://gen2-petportal-wow-uat.petsure.com.au',
        ssoLoginUrl: 'https://preprod-insurance.everyday.com.au/my-ins-portal/mip.html/login'
      },
      preprod: {
        authenticationType: '1', // Use 1 value for Auth0 SSO Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'petportal-auth-preprod.everydaypetinsurance.com.au',
        appClientId: '1niXwK1CKMQ2EqfHwHanJOqP6QZTUcxw',
        cspMfaUrl: '',
        gen2CspUrl: 'https://gen2-petportal-preprod.everydaypetinsurance.com.au',
        ssoLoginUrl: 'https://preprod-insurance.everyday.com.au/my-ins-portal/mip.html/login'
      },
      prod: {
        authenticationType: '1', // Use 1 value for Auth0 SSO Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'petportal-auth.everydaypetinsurance.com.au',
        appClientId: 'ZsZD5EqcugWJv2B4bGqvYfwAei2dZajT',
        cspMfaUrl: '',
        gen2CspUrl: 'https://gen2-petportal.everydaypetinsurance.com.au',
        ssoLoginUrl: 'https://insurance.everyday.com.au/my-ins-portal/mip.html/login'
      }
    },
    creditCardConfig: {
      sit: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      uat: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      preprod: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      prod: {
        formUrl: 'https://quickweb.westpac.com.au/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      paynowSupplierBusinessCode: 'RTCC',
      paynowSupplierBusinessCodePetsure: 'RTCC_PS'
    },
    bannerImage: {
      nonprod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/bg/bg_edi.jpg',
      prod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/bg/bg_edi.jpg'
    },
    customFaviconUrl: {
      nonprod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/favicon/edi_favicon.png',
      prod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/favicon/edi_favicon.png'
    },
    headerLogo: {
      nonprod: {
        imageUrl: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/logo/edi-logo.png',
        imageTitle: '',
        imageTitleDescription: '',
        redirectUrl: CSPUrlsMap.dashboard.url
      },
      prod: {
        imageUrl: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/logo/edi-logo.png',
        imageTitle: '',
        imageTitleDescription: '',
        redirectUrl: CSPUrlsMap.dashboard.url
      }
    },
    footerLogo: {
      nonprod: {
        imageUrl: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/footer/footer_edi.png',
        imageTitle: 'Everyday Pet Insurance',
        imageTitleDescription: 'Everyday Pet Insurance Logo'
      },
      prod: {
        imageUrl: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/footer/PIA_footer_edi.png',
        imageTitle: 'Everyday Pet Insurance',
        imageTitleDescription: 'Everyday Pet Insurance Logo'
      }
    },
    termsOfUseUrl:
      'https://petcdnstore.blob.core.windows.net/csp-common/pdfs/terms_of_use/Customer_Portal_Terms_of_Use_092024.pdf',
    header: {
      layoutConfig: {
        small: 'hamburger',
        large: 'horizontal'
      }
    },
    faqRedirection: {
      excessTooltip: {
        category: 'claims',
        question: 'How is my claim benefit calculated?'
      },
      editName: {
        category: 'policy management',
        question: `Why can't I edit my name in the Pet Portal?`
      },
      addYourVet: {
        category: 'getting started',
        question: 'Adding your vet to your account'
      }
    },
    gtm: {
      id: 'GTM-56PVBTDH',
      dataLayer: 'dataLayer'
    },
    seo: {
      title: 'Everyday Pet Insurance - Pet Portal Login',
      description:
        'Access your Everyday Pet Insurance Pet Portal to manage your pet policy, access 24/7 Live Vet support and to submit and track your claims.'
    }
  }
};
